module.exports = __webpack_public_path__ + "static/img/InformationDetails-banner.126c1993.png";